export default {"src":"/_next/static/media/2.ed2593fb.svg","height":38,"width":38};